import { ErrorInfo } from '../../common/twshared/errorHandling/ErrorInfo';
import { RequestError } from '../../common/RequestError';

angular.module('tromanWeb').config(['ergoErrorParserProvider', function (ergoErrorParserProvider) {
    ergoErrorParserProvider.parse = function parseApiError(err) {
        if (err instanceof RequestError) {
            if (err.result.TWCode === 'PersonDuplicatePersonalNumber') {
                let detail = err.result.TWDetail;
                let name = detail.FirstName ? detail.FirstName + ' ' + detail.LastName : detail.LastName;
                let location = name + ', ' + detail.PersonalNumber;

                let messages = [err.result.detail, { highlight: true, text: location }];

                let result = new ErrorInfo('tparse_PersonDuplicatePersonalNumber', messages);
                result.actiontext = 'Visa person';
                result.action = ['stateService', function (stateService) {
                    stateService.forceGo('person.details', { personId: detail.Id }, { reload: true, inherit: false });
                }];
                return result;
            }
        }
    };
}]);
